import React, { useEffect, useState } from "react";
import downloadImg from "../../images/download.svg";
import QuoteVersionPriceBox from "../QuoteVersionPriceBox/QuoteVersionPriceBox";
import { fetchQuoteByIdForQuoteVersion } from "../../utils/actions/allactions";
import { config } from "../../environment/development";
import fileSaver from "file-saver";
import {
  currencyFormatter,
  extractURLAndEncodedFilename,
} from "../../utils/helper";
import { Loading } from "../Loading";
import { toast } from "react-toastify";
import { DownloadIcon } from "../Icons";

function QuoteTable({
  selectedQuote,
  setSelectedQuote,
  fromOrderDetails,
  showDrawer,
}) {
  const download = async (name, url) => {
    const data = extractURLAndEncodedFilename(url);
    let fileUrl = `${data.url}/${data.encodedFilename}`;
    fileSaver.saveAs(fileUrl, name);
  };

  const [fetchedQuoteDetails, setFetchedQuoteDetails] = useState();
  let token = localStorage.getItem("Token");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [selectedShipMethod, setSelectedShipMethod] = useState(0);

  const fetchedQuoteDetailsById = async () => {
    try {
      let details = await fetchQuoteByIdForQuoteVersion(
        selectedQuote._id,
        token
      );
      setSelectedShipMethod(details.data.data.selectedShipMethod);
      setFetchedQuoteDetails(details.data.data);
    } catch (error) {
      toast.error("Unable To Fetch Quotes Details");
    }
  };

  useEffect(() => {
    if (selectedQuote._id) {
      fetchedQuoteDetailsById();
    }

    if (selectedQuote.selectedProcess >= 3) {
      setSelectedPrice(selectedQuote.sheetAndInjectionManualPrice);
    } else {
      setSelectedPrice(selectedQuote.stManualPrice);
    }
  }, [selectedQuote]);

  let handleOnClickPriceBox = (price, selectedShipMethod) => {
    setSelectedPrice(price);
    setSelectedShipMethod(selectedShipMethod);
    // setSelectedQuote({ ...selectedQuote, selectedShipMethod: selectedShipMethod })
  };

  let getFileExtension = (filename) => {
    return filename?.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
  };

  if (!fetchedQuoteDetails) {
    return <Loading />;
  }

  return (
    <div>
      {!fromOrderDetails && (
        <QuoteVersionPriceBox
          showDrawer={showDrawer}
          selectedQuote={selectedQuote}
          handleOnClickPriceBox={handleOnClickPriceBox}
          selectedPrice={selectedPrice}
          selectedShipMethod={selectedShipMethod}
          setSelectedShipMethod={setSelectedShipMethod}
          setSelectedQuote={setSelectedQuote}
        />
      )}

      <div className="relative overflow-x-auto">
        <table className="qoute-version-table">
          {fetchedQuoteDetails.selectedProcess >= 3 ? (
            <>
              <thead>
                <tr className="heading-row">
                  <th scope="col">File Name</th>
                  <th scope="col">Part Description</th>
                  <th scope="col">Notes</th>
                  <th scope="col">Price</th>
                  <th scope="col">Qty</th>
                  <th scope="col">Amount</th>
                </tr>
              </thead>
              <tbody>
                {(selectedShipMethod == 0
                  ? fetchedQuoteDetails.shippingCharge1
                  : selectedShipMethod == 1
                    ? fetchedQuoteDetails.shippingCharge2
                    : fetchedQuoteDetails.shippingCharge3) &&
                  ((fetchedQuoteDetails.isUpdatedByAdmin &&
                    fetchedQuoteDetails.isSent) ||
                    fetchedQuoteDetails.myorders ||
                    fetchedQuoteDetails.isRepeatOrderQuotation) ? (
                  <tr>
                    <td> </td>
                    <td>Shipping & Duties </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <div className="amt">
                        <p className="un-fld">
                          {currencyFormatter(
                            selectedShipMethod == 0
                              ? fetchedQuoteDetails.shippingCharge1
                              : selectedShipMethod == 1
                                ? fetchedQuoteDetails.shippingCharge2
                                : fetchedQuoteDetails.shippingCharge3
                          )}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}

                {fetchedQuoteDetails.partsData?.length > 0 &&
                  fetchedQuoteDetails.partsData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td
                          // className="downloadables"
                          style={{
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                            width: "250px",
                          }}
                        >
                          <div className="flex items-center gap-x-2">
                            {(item.file
                              ? item.file.originalname || item.file.filename
                              : item.selectedFile
                                ? item?.selectedFile?.path ||
                                item?.selectedFile?.name
                                : item.linePartName || "No file uploaded"
                            )?.length > 25
                              ? (item.file
                                ? item.file.originalname ||
                                item.file.filename
                                : item.selectedFile
                                  ? item?.selectedFile?.path ||
                                  item?.selectedFile?.name
                                  : item.linePartName || "No file uploaded"
                              ).substring(0, 25) + "..."
                              : item.file
                                ? item.file.originalname || item.file.filename
                                : item.selectedFile
                                  ? item?.selectedFile?.path ||
                                  item?.selectedFile?.name
                                  : item.linePartName || "No file uploaded"}{" "}
                            {item.file ? (
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  let extension = getFileExtension(
                                    item.file.originalname
                                  );
                                  let url = `${config.backEnd}/public/uploads/${item._id}.${extension}`;
                                  download(item.file.originalname, url);
                                }}
                              >
                                <img src={downloadImg} />
                              </span>
                            ) : null}
                          </div>
                        </td>

                        <td
                          style={{
                            textAlign: "left",
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                            width: "250px",
                          }}
                        >
                          {item.description ? item.description : ""}
                        </td>

                        <td
                          style={{
                            textAlign: "left",
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                            width: "250px",
                          }}
                        >
                          {item.Notes ? item.Notes : ""}
                        </td>

                        <td>
                          {(fetchedQuoteDetails.isUpdatedByAdmin &&
                            fetchedQuoteDetails.isSent) ||
                            fetchedQuoteDetails.myorders ||
                            fetchedQuoteDetails.isRepeatOrderQuotation ? (
                            <>
                              <div className="amt">
                                <p className="un-fld">
                                  {currencyFormatter(
                                    selectedShipMethod === 0
                                      ? Number(item?.price).toFixed(2)
                                      : selectedShipMethod === 1
                                        ? Number(item?.price1).toFixed(2)
                                        : Number(item?.price2).toFixed(2)
                                  )}
                                </p>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>

                        <td>{item.Qty ? item.Qty : "No quantity found"}</td>

                        <td>
                          {(fetchedQuoteDetails.isUpdatedByAdmin &&
                            fetchedQuoteDetails.isSent) ||
                            fetchedQuoteDetails.isRepeatOrderQuotation ||
                            fetchedQuoteDetails.myorders ? (
                            <>
                              <div className="amt">
                                <p className="un-fld">
                                  {currencyFormatter(
                                    selectedShipMethod === 0
                                      ? (
                                        Number(item?.price) *
                                        Number(item?.Qty)
                                      ).toFixed(2)
                                      : selectedShipMethod === 1
                                        ? (
                                          Number(item?.price1) *
                                          Number(item?.Qty)
                                        ).toFixed(2)
                                        : Number(
                                          Number(item?.price2) *
                                          Number(item?.Qty)
                                        ).toFixed(2)
                                  )}
                                </p>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                    );
                  })}

                {(fetchedQuoteDetails.isQrTrackingRequested ||
                  (selectedShipMethod == 0
                    ? fetchedQuoteDetails.additionalCost1
                    : selectedShipMethod == 1
                      ? fetchedQuoteDetails.additionalCost2
                      : fetchedQuoteDetails.additionalCost3)) &&
                  ((fetchedQuoteDetails.isUpdatedByAdmin &&
                    fetchedQuoteDetails.isSent) ||
                    fetchedQuoteDetails.myorders ||
                    fetchedQuoteDetails.isRepeatOrderQuotation) ? (
                  <tr>
                    <td> </td>
                    <td>QR Tracking</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <div className="amt">
                        <p className="un-fld">
                          {currencyFormatter(
                            selectedShipMethod == 0
                              ? fetchedQuoteDetails.additionalCost1
                              : selectedShipMethod == 1
                                ? fetchedQuoteDetails.additionalCost2
                                : fetchedQuoteDetails.additionalCost3
                          )}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
              </tbody>
            </>
          ) : (
            <>
              <thead>
                <tr className="heading-row">
                  <th scope="col">File Name</th>
                  <th scope="col">Part Description</th>
                  <th scope="col">Notes</th>
                  <th scope="col">Price</th>
                  <th scope="col">Qty</th>
                  <th scope="col">Amount</th>
                </tr>
              </thead>
              <tbody>
                {(selectedShipMethod == 0
                  ? fetchedQuoteDetails.shippingCharge1
                  : selectedShipMethod == 1
                    ? fetchedQuoteDetails.shippingCharge2
                    : fetchedQuoteDetails.shippingCharge3) &&
                  ((fetchedQuoteDetails.isUpdatedByAdmin &&
                    fetchedQuoteDetails.isSent) ||
                    fetchedQuoteDetails.myorders ||
                    fetchedQuoteDetails.isRepeatOrderQuotation) ? (
                  <tr>
                    <td> </td>
                    <td>Shipping & Duties</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <div className="amt">
                        <p className="un-fld">
                          {currencyFormatter(
                            selectedShipMethod == 0
                              ? fetchedQuoteDetails.shippingCharge1
                              : selectedShipMethod == 1
                                ? fetchedQuoteDetails.shippingCharge2
                                : fetchedQuoteDetails.shippingCharge3
                          )}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}

                {fetchedQuoteDetails.partsData.length > 0 &&
                  fetchedQuoteDetails.partsData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td
                          style={{
                            wordWrap: "break-word",
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                            width: "280px",
                          }}
                        >
                          <div
                            className="prd-thumb downloadables"
                            // style={{ color: "dodgerblue" }}
                          >
                            <p className="flex justify-start gap-x-3 whitespace-nowrap !text-primaryColor">
                              {(item.file ? item?.file?.originalname : "")
                                ?.length > 25
                                ? (item.file
                                  ? item?.file?.originalname
                                  : ""
                                ).substring(0, 25) + "..."
                                : item.file
                                  ? item?.file?.originalname
                                  : ""}
                              <span
                                onClick={(e) => {
                                  let extension = getFileExtension(
                                    item?.file?.originalname
                                  );
                                  let url = `${config.backEnd}/public/uploads/${item._id}.${extension}`;
                                  download(item?.file?.originalname, url);
                                }}
                              >
                                <DownloadIcon />
                              </span>
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className="desc-part-quote-version">
                            <ul>
                              {item?.description ? (
                                <li>{item?.description}</li>
                              ) : (
                                ""
                              )}
                              {item?.MaterialType ? (
                                <li>{item?.MaterialType?.name}</li>
                              ) : (
                                ""
                              )}
                              {item?.SubMaterial ? (
                                <li>{item?.SubMaterial.name}</li>
                              ) : (
                                ""
                              )}
                              {item?.surfaceFinish ? (
                                <li>{item?.surfaceFinish.name}</li>
                              ) : (
                                ""
                              )}
                              {item?.surfaceTreatment ? (
                                <li>{item?.surfaceTreatment.name}</li>
                              ) : (
                                ""
                              )}
                              {item?.tolerance ? (
                                <li>{item?.tolerance.name}</li>
                              ) : (
                                ""
                              )}
                              {item?.partMarking ? (
                                <li>{item?.partMarking.name}</li>
                              ) : (
                                ""
                              )}
                              {item?.noOfThread ? (
                                <li>{item?.noOfThread}</li>
                              ) : (
                                ""
                              )}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <p className="3dcncNote">{item?.Notes}</p>{" "}
                        </td>

                        <td>
                          {(fetchedQuoteDetails.isUpdatedByAdmin &&
                            fetchedQuoteDetails.isSent) ||
                            fetchedQuoteDetails.myorders ||
                            fetchedQuoteDetails.isRepeatOrderQuotation ? (
                            <>
                              <div className="amt">
                                <p className="un-fld">
                                  {currencyFormatter(
                                    selectedShipMethod === 0
                                      ? Number(item?.price).toFixed(2)
                                      : selectedShipMethod === 1
                                        ? Number(item?.price1).toFixed(2)
                                        : Number(item?.price2).toFixed(2)
                                  )}
                                </p>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>

                        <td>
                          <p className="amt">{item?.Qty}</p>{" "}
                        </td>

                        <td>
                          {(fetchedQuoteDetails.isUpdatedByAdmin &&
                            fetchedQuoteDetails.isSent) ||
                            fetchedQuoteDetails.isRepeatOrderQuotation ||
                            fetchedQuoteDetails.myorders ? (
                            <>
                              <div className="amt">
                                <p className="un-fld">
                                  {currencyFormatter(
                                    selectedShipMethod === 0
                                      ? (
                                        Number(item?.price) *
                                        Number(item?.Qty)
                                      ).toFixed(2)
                                      : selectedShipMethod === 1
                                        ? (
                                          Number(item?.price1) *
                                          Number(item?.Qty)
                                        ).toFixed(2)
                                        : Number(
                                          Number(item?.price2) *
                                          Number(item?.Qty)
                                        ).toFixed(2)
                                  )}
                                </p>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                      </tr>
                    );
                  })}

                {(fetchedQuoteDetails.isQrTrackingRequested ||
                  (selectedShipMethod == 0
                    ? fetchedQuoteDetails.additionalCost1
                    : selectedShipMethod == 1
                      ? fetchedQuoteDetails.additionalCost2
                      : fetchedQuoteDetails.additionalCost3)) &&
                  ((fetchedQuoteDetails.isUpdatedByAdmin &&
                    fetchedQuoteDetails.isSent) ||
                    fetchedQuoteDetails.isRepeatOrderQuotation ||
                    fetchedQuoteDetails.myorders) ? (
                  <tr>
                    <td> </td>
                    <td>QR Tracking</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <div className="amt">
                        <p className="un-fld">
                          {currencyFormatter(
                            selectedShipMethod == 0
                              ? fetchedQuoteDetails.additionalCost1
                              : selectedShipMethod == 1
                                ? fetchedQuoteDetails.additionalCost2
                                : fetchedQuoteDetails.additionalCost3
                          )}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
              </tbody>
            </>
          )}
        </table>
      </div>
    </div>
  );

}

export default QuoteTable;